module.exports = __webpack_public_path__ + "img/issues.6c6be46b.svg";